// assets
import {
  ApiOutlined,
  FolderOpenOutlined,
  FileTextOutlined,
  ReadOutlined,
  SafetyOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';

const icons = {
  ApiOutlined,
  FolderOpenOutlined,
  FileTextOutlined,
  ReadOutlined,
  SafetyOutlined,
  SafetyCertificateOutlined
};

const setup = {
  id: 'group-setup',
  title: 'Setup',
  type: 'group',
  children: [
    {
      id: 'integrations',
      title: 'Integrations',
      type: 'item',
      url: '/integrations',
      icon: icons.ApiOutlined
    },
    {
      id: 'policies',
      title: 'Policies',
      type: 'item',
      url: '/policies',
      icon: icons.FileTextOutlined
    },
    {
      id: 'access-reviews',
      title: 'Access Reviews',
      type: 'item',
      url: '/access-reviews',
      icon: icons.SafetyCertificateOutlined
    },
    {
      id: 'security-reviews',
      title: 'Security Reviews',
      type: 'item',
      url: '/security-reviews',
      icon: icons.SafetyOutlined
    },
    {
      id: 'audit-packet',
      title: 'Audit Packet',
      type: 'item',
      url: '/audit-packet',
      icon: icons.FolderOpenOutlined
    },
    {
      id: 'program-work',
      title: 'Compliance Operations',
      type: 'item',
      url: '/program-work',
      icon: icons.ReadOutlined
    }
  ]
};

export default setup;
